import { SearchHistory } from "../model/SearchHistory.js";
import {composeSearchStringFromParams, decomposeSearchStringToParams} from "./urlHandler";

/**
 * @type {string[]}
 */
const searchHistoryProps = ['searchString', 'addTime'];


/**
 * 検索履歴を保存する
 *
 * @return {void}
 */
export const saveSearchHistory = () => {
    // 検索結果URLの最後の"/"の後の文字列 (例: Remote-jobs-in-New-York,-NY?r=10&dp=3&jt=1&pg=2)
    const currentSearchString = location.href.split('/')[3];
    // 一度パラメータに分解し、不要なパラメータは除去する
    const searchParam = decomposeSearchStringToParams(currentSearchString);
    // 検索履歴保存の上ではjbパラメータ(unique_id)とpgパラメータ(ページ番号)が不要なので削除
    searchParam.uniqueId = '';
    searchParam.page = '';

    // 正規化された検索文字列(検索URL末尾の文字列)を作る
    const normalizedCurrentSearchString = composeSearchStringFromParams(searchParam);
    const currentSearch = new SearchHistory(normalizedCurrentSearchString);

    // 新しい検索履歴との重複を除いて取得
    const searchHistory = fetchSearchHistory().filter(
        search => search['searchString'] !== currentSearch.searchString
    );
    searchHistory.unshift(currentSearch);

    // 30件を超えたら削除
    while (searchHistory.length > 30) {
        searchHistory.pop();
    }

    updateAll(searchHistory);
}

/**
 * ローカルストレージから検索履歴を取ってくる
 *
 * @return {SearchHistory[]}
 */
export const fetchSearchHistory = () => {
    const searchHistoryJson = localStorage.getItem('search_history');
    const searchHistory = JSON.parse(searchHistoryJson);

    if (!Array.isArray(searchHistory)) {
        return [];
    }

    return validate(searchHistory);
}

/**
 * ローカルストレージを更新する
 *
 * @param {SearchHistory[]} searchHistory
 * @return {void}
 */
export const updateAll = (searchHistory) => {
    localStorage.setItem('search_history', JSON.stringify(searchHistory));
}

/**
 * @param {SearchHistory[]} searchHistory
 * @return {SearchHistory[]}
 */
const validate = (searchHistory) => {
    return searchHistory.filter((search) => {
        return (
            searchHistoryProps.every((prop) => search[prop] !== undefined)
            && !search.searchString.includes('/')
        );
    });
}
